<template>
  <!-- 🎛️ Modal des paramètres de page -->
  <teleport to="body">
    <div
      v-if="visible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0,0,0,0.5);"
      @click.self="closeModal"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" @click.stop>
        <div class="modal-content shadow">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-cog me-2"></i>
              Paramètres de page - {{ pageData?.label || 'Page' }}
            </h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <PageParameter 
              v-if="pageData" 
              :pageData="pageData"
              @close="closeModal"
              @apply="handleApplyParameters"
            />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import PageParameter from "./PageParameter.vue";

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  pageData: {
    type: Object,
    default: null
  }
});

// Émissions
const emit = defineEmits(['close', 'apply']);

// Méthodes
const closeModal = () => {
  emit('close');
};

const handleApplyParameters = (parameterData) => {
  console.log("🎛️ Paramètres reçus dans la modal:", parameterData);
  emit('apply', parameterData);
  closeModal();
};
</script>

<style scoped>
/* Styles personnalisés pour la modal */
.modal-dialog {
  max-width: 1200px;
  width: 95vw;
}

.modal-content {
  height: 85vh;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Animation d'entrée pour la modal */
.modal.show {
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  animation: slideIn 0.15s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>